module.exports = __webpack_public_path__ + "img/frame-mb.de318e1f.png";